import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {SeoMetaValueObject} from './SeoMetaValueObject.js'

const metaNames = {
  description: 'description',
  keywords: 'keywords',
  robots: 'robots'
}

export class ListSeoMetaValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static #buildRobotsTag({isIndexable}) {
    const isDevEnv = ConfigContext.get('IS_DEV')
    const {DEVELOPMENT_META_ROBOTS, CRAWLABLE_AND_INDEXABLE_META_ROBOTS} = ConfigContext.get('seo')
    return isIndexable && !isDevEnv ? CRAWLABLE_AND_INDEXABLE_META_ROBOTS : DEVELOPMENT_META_ROBOTS
  }

  static create({description, keywords, isIndexable = false}) {
    const meta = []
    if (description) {
      meta.push({name: metaNames.description, content: description})
    }
    if (keywords) {
      meta.push({name: metaNames.keywords, content: keywords})
    }

    meta.push({name: metaNames.robots, content: this.#buildRobotsTag({isIndexable})})

    return new ListSeoMetaValueObject({value: meta.map(SeoMetaValueObject.create)})
  }

  get value() {
    return this.#value.map(meta => meta.value)
  }

  toJSON() {
    return {value: this.#value.map(meta => meta.toJSON())}
  }
}
